module.exports = __webpack_public_path__ + "static/img/outlook1.7e31322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/outlook1.png
// module id = 1428
// module chunks = 1